var EvaluationService = {
  initialize: function(evaluationMap) {
    evaluationMap = (evaluationMap || {});
    this.mapping = evaluationMap;
  },

  getResponseSet: function(courseSlug) {
    let fakeResponseSet = { id: 'local', token: 'not-real', endpoint: 'http://nowhere.dev' };
    if(this.mapping && this.mapping[courseSlug]) {
      return this.mapping[courseSlug];
    } else {
      return fakeResponseSet;
    }
  },

  userHasPassedEvaluation: function(courseSlug) {
    const responseSet = this.findEvaluationBySlug(courseSlug);
    if(responseSet) {
      return responseSet.get('grading_status') === 'passed';
    }
  },

  userHasCompletedEvaluation: function(courseSlug) {
    const responseSet = this.findEvaluationBySlug(courseSlug);
    if(responseSet) {
      var completed = responseSet.get('has_been_completed') || responseSet.get('status') === 'completed' || this.mapping[courseSlug].status === 'skipped';
      if(completed) {
        this.refreshResponseSet(courseSlug);
      }
      return completed;
    }
  },

  shouldSkip: function(slug) {
    var responseSet = this.getResponseSet(slug);
    return responseSet && responseSet.status && responseSet.status === 'skipped';
  },

  getResponseSetFromModel: function(courseSlug) {
    var evaluation = this.findEvaluationBySlug(courseSlug);
    const responseSet = evaluation ? evaluation.get('responseSet') : null;

    if(responseSet) {
      responseSet.endpoint = evaluation.get('endpoint');
      responseSet.id = evaluation.get('id');
    }
    return responseSet;
  },

  findEvaluationBySlug: function(slug) {
    var courseSlugId = this.mapping[slug] ? this.mapping[slug].id : null;
    return courseSlugId ? EF.responseSet.models.find((model) => { return model.get('id') === courseSlugId; }) : null;
  },

  findEvaluationTokenBySlug: function(slug) {
    return this.mapping[slug].token;
  },

  expandedResponseSet: function(slug) {
    const responseSet = this.findEvaluationBySlug(slug);
    let options = EF.options.local ? {} : {
        parse: true,
        headers: {'Authorization': `Bearer ${responseSet.get('token')}`}
      };
    responseSet.includes = 'evaluation,sections.questions.answers,classifications'; 
    return responseSet.fetch(options);
  },

  updateResponseSet: function(slug, newResponseSet) {
    const responseSet = this.findEvaluationBySlug(slug);
    if (responseSet && responseSet.id !== newResponseSet.id) {
      this.mapping[slug] = newResponseSet;
      responseSet.id = newResponseSet.id;
      responseSet.token = newResponseSet.token;
      responseSet.set('id', newResponseSet.id);
      responseSet.set('token', newResponseSet.token);
    }
    this.refreshResponseSet(slug);
  },

  refreshResponseSet: function(slug) {
    // findEvaluationBySlug called twice.
    const responseSet = this.findEvaluationBySlug(slug);
    if(responseSet) {
      let options = EF.options.local ? {} : {
          parse: true,
          headers: {'Authorization': `Bearer ${responseSet.get('token')}`}
        };
      responseSet.includes = 'classifications';
      return responseSet.fetch(options);
    }
    return new Promise(resolve => resolve());
  },

  bestScore: function(courseSlug) {
    var responseSet = this.findEvaluationBySlug(courseSlug);
    return responseSet && responseSet.has('best_grade') ? responseSet.get('best_grade'): 0;
  }
};

module.exports = EvaluationService;
